import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { FEATURE_FLAG_MULTI_CAROUSEL_V2 } from '@monofront/business/constants';
import MultipleProductsCarousels from './MultipleProductsCarousels';
import MultipleProductsCarouselsV2 from './MultipleProductsCarouselsV2';
import React from 'react';
import { MultipleProductsCarouselsSlice } from '@monofront/slice-machine/prismicio-types';

const MemoizedMultipleProductsCarousels = React.memo(MultipleProductsCarousels);
const MemoizedMultipleProductsCarouselsV2 = React.memo(
  MultipleProductsCarouselsV2,
);

const MultipleProductsCarouselsContainer = ({
  prismicContent,
}: {
  prismicContent: MultipleProductsCarouselsSlice;
}) => {
  const isCarouselAbTestOn = useFeatureIsOn(FEATURE_FLAG_MULTI_CAROUSEL_V2);

  if (
    isCarouselAbTestOn ||
    prismicContent.variation === 'multiproductscarouselsreco'
  ) {
    return (
      <MemoizedMultipleProductsCarouselsV2 prismicContent={prismicContent} />
    );
  }

  return <MemoizedMultipleProductsCarousels prismicContent={prismicContent} />;
};

export default MultipleProductsCarouselsContainer;
